<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

defineProps({
  stage: { type: Object, required: true },
});
const emit = defineEmits(['edit', 'delete']);

const open = ref(false);
const rootEl = ref(null);

function toggle(e) {
  e?.stopPropagation();
  open.value = !open.value;
}

function close() {
  open.value = false;
}

function handleClickOutside(e) {
  if (!open.value) return;
  if (rootEl.value && !rootEl.value.contains(e.target)) close();
}

onMounted(() => document.addEventListener('click', handleClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside));
</script>

<template>
  <div ref="rootEl" class="relative">
    <button
      class="size-5 grid place-content-center rounded hover:bg-n-alpha-1 text-n-slate-10 hover:text-n-slate-12"
      title="Ações da etapa"
      @click="toggle"
    >
      <span class="i-lucide-more-vertical size-3.5" />
    </button>
    <div
      v-if="open"
      class="absolute right-0 top-7 z-30 w-44 bg-n-solid-2 border border-n-weak rounded-md shadow-lg py-1 text-sm"
    >
      <button
        class="w-full text-left px-3 py-1.5 hover:bg-n-alpha-1 text-n-slate-12"
        @click="emit('edit'); close()"
      >
        Editar etapa
      </button>
      <button
        class="w-full text-left px-3 py-1.5 text-red-600 hover:bg-red-50 dark:hover:bg-red-950/30"
        @click="emit('delete'); close()"
      >
        Excluir etapa
      </button>
    </div>
  </div>
</template>
